import { SkinElement } from "../skin.js";
import { template } from "../../internal/skins/minimal-live-audio/template.js";
import minimal_skin_default from "../../define/live-audio/minimal-skin2.js";
import { createShadowStyle } from "@videojs/utils/dom";
//#region src/presets/live-audio/minimal-skin.ts
/** Packaged Minimal live-audio UI registered as `<live-audio-minimal-skin>`. */
var MinimalLiveAudioSkinElement = class extends SkinElement {
	static {
		this.tagName = "live-audio-minimal-skin";
	}
	static {
		this.styles = createShadowStyle(minimal_skin_default);
	}
	static {
		this.template = template;
	}
};
//#endregion
export { MinimalLiveAudioSkinElement };
